<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        New Payment Method
      </content-page-title>
    </template>

    <Section>

      <div v-if="loading" class="text-center align-center py-8">
        Loading...
      </div>

      <div v-show="!loading" ref="stripe_pm" />


      <div v-if="setupCompleted && !me.auto_refill_enabled">
        <v-checkbox v-model="autoRefill" dense hide-details class="mb-4" :disabled="loading">
        <template #label>
            <div style="font-size: 12px; line-height: 1.25;">
              Enable auto-refill of your account.   You can adjust your settings on your auto-refill page.
            </div>
          </template>
        </v-checkbox>
      </div>

      <v-divider class="mt-4" v-if="setupCompleted"/>

      <div class="d-flex justify-center mt-4 mb-2" v-if="setupCompleted">
        <v-btn @click="$router.back()">Cancel</v-btn>
        <v-btn :disabled="loading" 
          color="primary" class="ml-2"
          @click="onCreateClick"
        >
          Create
        </v-btn>
      </div>
    </Section>
    <ErrorOverlay
      title="Payment Method Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </ContentPage>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ContentPage, ContentPageTitle, ErrorOverlay, Section } from '@/components/pages'

let elements = null

export default {
  name: 'BillingNewPaymentMethodView',

  components: { ContentPage, ContentPageTitle, ErrorOverlay, Section },

  data: () => ({
    autoRefill: true,
    setupComplete: null,
    setupCompleted: false,
    paymentElement: null,

    // error handling
    loading: true,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    ...mapGetters('payment_methods', ['paymentSecret']),
    ...mapGetters('auth', ['me']),
  },

  methods: {
    ...mapActions('payment_methods', ['loadPaymentSecret']),

    async onCreateClick() {
      this.loading = true 

      let return_url = `${ location.origin }/billing/account`
      if(!this.me.auto_refill_enabled) {
        return_url += `?refill=${ this.autoRefill ? 'enable' : 'disable'}`
      }

      const { error } = await this.$stripe.confirmSetup({
        elements,

        confirmParams: {
          return_url,
          payment_method_data: {
            billing_details: {
              address: {
                country: 'US',
              },
            },
          },
        },
      })

      if (error) {
        this.error_message = 'Our credit card processor is unable to accept this card.  Please check you that have the correct number, CVC and zip code.'
        this.error_dialog = true
        this.loading = false
      }
    },
  },

  created() {
    this.setupComplete = new Promise( (resolve) => {
      this.loadPaymentSecret().then( () => {
        const appearance = {
          theme: 'stripe',

          variables: {
            colorPrimary: this.$vuetify.theme.themes.light.primary,
            fontFamily: 'Roboto, sans-serif',
          }
        }

        const clientSecret = this.paymentSecret.client_secret

        elements = this.$stripe.elements({
          clientSecret,
          appearance,
        })
        
        const fields = {
          billingDetails: {
            address: {
              country: 'never',
            },
          },
        }

        this.paymentElement = elements.create('payment', { fields })
        this.paymentElement.on('ready', () => { 
          this.loading = false
          this.setupCompleted = true 
        })
        resolve(true)
      })
    })
  },

  async mounted() {  
    await this.setupComplete
        
    this.paymentElement.mount(this.$refs.stripe_pm)
  },
}
</script>